const optionalSharedConfigFields = [
  { key: 'listeners', isOptional: true, type: 'object' },
  { key: 'customUtiqHost', isOptional: true, type: 'string' },
  { key: 'consentManagerOrigin', isOptional: true, type: 'string' },
  { key: 'consentManagerDataLayer', isOptional: true, type: 'boolean' },
  { key: 'oncePerTimeInterval', isOptional: true, type: 'number' },
  { key: 'customizationCSS', isOptional: true, type: 'object' },
  { key: 'variation', isOptional: true, type: 'string' },
  { key: 'customizationOptions', isOptional: true, type: 'object' },
  { key: 'getNewConsentBeforeExpiry', isOptional: true, type: 'boolean' },
  { key: 'integrations', isOptional: true, type: 'object' },
  { key: 'language', isOptional: true, type: 'string' },
  { key: 'logLevel', isOptional: true, type: 'string' },
  {
    key: 'connectionEligibilityRetryInterval',
    isOptional: true,
    type: 'number',
  },
];

const requiredSharedConfigFields = [
  { key: 'utiqHost', isOptional: false, type: 'string' },
  { key: 'apiPath', isOptional: false, type: 'string' },
  { key: 'oncePerSession', isOptional: false, type: 'boolean' },
];

export const OptanonData = {
  name: 'Optanon',
  fieldsTemplate: [
    { key: 'CMP', isOptional: false, type: 'string' },
    { key: 'useGroups', isOptional: true, type: 'boolean' },
    { key: 'cmpUtiqPurposeId', isOptional: false, type: 'string' },
    { key: 'cmpUtiqVendorId', isOptional: false, type: 'string' },
    ...requiredSharedConfigFields,
    ...optionalSharedConfigFields,
  ],
  groupsString: 'groups',
  vendorsString: 'genVendors',
  cookieName: 'OptanonConsent',
};

export const DidomiData = {
  name: 'Didomi',
  fieldsTemplate: [
    { key: 'CMP', isOptional: false, type: 'string' },
    { key: 'didomiUtiqPurposeId', isOptional: false, type: 'string' },
    { key: 'didomiUtiqVendorId', isOptional: false, type: 'string' },
    ...requiredSharedConfigFields,
    ...optionalSharedConfigFields,
  ],
};

export const CustomData = {
  name: 'Custom',
  fieldsTemplate: [
    { key: 'CMP', isOptional: true, type: 'string' },
    { key: 'consentManagerDataLayer', isOptional: true, type: 'boolean' },
    ...requiredSharedConfigFields,
    ...optionalSharedConfigFields,
  ],
};

export const AgnosticData = {
  name: 'none',
  fieldsTemplate: [
    { key: 'CMP', isOptional: true, type: 'string' },
    { key: 'consentManagerDataLayer', isOptional: true, type: 'boolean' },
    ...requiredSharedConfigFields,
    ...optionalSharedConfigFields,
  ],
};
